import { Auth } from 'aws-amplify';

const amplifyConfig = {
  // REQUIRED - Amazon Cognito Region
  region: 'eu-west-1',

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: process.env.REACT_APP_USERPOOL,
  identityPoolId: process.env.REACT_APP_IDENTITY,

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
  aws_pubsub_region: 'eu-west-1',
  aws_pubsub_endpoint: process.env.REACT_APP_PUBSUB_ENDPOINT,

  API: {
    endpoints: [
      {
        name: 'tracking',
        endpoint: process.env.REACT_APP_TRACKING_INFO,
        authorizationType: 'AWS_IAM'
      },
      {
        name: 'uruk-back',
        endpoint: process.env.REACT_APP_URUK_API_URL,
        custom_header: async () => {
          const idToken = (await Auth.currentSession())
            .getIdToken();
          return {
            Authorization: `Bearer ${idToken.getJwtToken()}`,
            'X-Api-Key': idToken.decodePayload().apiKey
          };
        }
      },
      {
        name: 'firma-back',
        endpoint: process.env.REACT_APP_FIRMA_API_URL,
        custom_header: async () => {
          const idToken = (await Auth.currentSession())
            .getIdToken();
          return {
            Authorization: `Bearer ${idToken.getJwtToken()}`,
            'X-Api-Key': idToken.decodePayload().apiKey
          };
        }
      },
      {
        name: 'admin-back',
        endpoint: process.env.REACT_APP_ADMIN_BACK_URL,
        custom_header: async () => {
          try {
            const currentSession = await Auth.currentSession();
            const idToken = currentSession.getIdToken();
            return {
              Authorization: `Bearer ${idToken.getJwtToken()}`,
              'X-Api-Key': idToken.payload.apiKey
            };
          } catch (err) {
            console.log(err);
            window.location.reload();
          }
        }
      }
    ]
  }
};

export default amplifyConfig;
